import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";
import { TableCell, ModalRef } from "@shared/components";

export const useDefaultPlanListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  editDefaultPlanModalRef: RefObject<ModalRef>
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("default_plan_admin.fields.id"),
        width: 80,
      },
      {
        field: "name",
        headerName: translate("default_plan_admin.fields.name"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text value={value} textAlign="left" />
        ),
      },
      {
        field: "description",
        headerName: 'Descrição',
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text value={value} textAlign="left" />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => editDefaultPlanModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              resource="v1/default_plan_admin"
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, editDefaultPlanModalRef]
  );
};
